import script from "./solutions.vue?vue&type=script&setup=true&lang=js"
export * from "./solutions.vue?vue&type=script&setup=true&lang=js"

import "./solutions.vue?vue&type=style&index=0&id=27565677&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27565677"]])

export default __exports__